/** Translation-bearing descriptor properties shared by build-time and runtime closure checks. */
export const TRANSLATION_BEARING_PROPERTIES = new Set([
    'i18nKey',
    'i18nKeyRef',
    'titleKey',
    'subtitleKey',
    'descriptionKey',
    'accessibilityLabelKey',
    'accessibilityDescriptionKey',
    'ariaLabelKey',
    'breadcrumbKey',
    'breadcrumbKeys',
    'labelKey',
    'actionLabelKey',
    'columnLabelKey',
    'tabLabelKey',
    'placeholderKey',
    'helpTextKey',
    'emptyStateKey',
    'emptyStateDescriptionKey',
    'partialStateKey',
    'disabledReasonKey',
    'messageKey',
    'errorMessageKey',
    'successMessageKey',
    'confirmationTitleKey',
    'confirmationMessageKey',
    'confirmLabelKey',
    'cancelLabelKey',
    'createTitleKey',
    'editTitleKey',
    'detailTitleKey',
    'listTitleKey',
    'prefixKey',
    'suffixKey',
    'emptyValueKey',
    'addLabelKey',
    'removeLabelKey',
    'itemLabelKey',
]);
export function normalizeTranslationKey(key) {
    if (!key.includes(':'))
        return key;
    const [namespace, ...rest] = key.split(':');
    return `${namespace}.${rest.join(':')}`;
}
export function collectTranslationReferences(node, path = 'descriptor', result = []) {
    if (!node || typeof node !== 'object')
        return result;
    if (Array.isArray(node)) {
        node.forEach((item, index) => collectTranslationReferences(item, `${path}[${index}]`, result));
        return result;
    }
    for (const [property, value] of Object.entries(node)) {
        const propertyPath = `${path}.${property}`;
        if (TRANSLATION_BEARING_PROPERTIES.has(property)) {
            if (typeof value === 'string') {
                result.push({ property, key: normalizeTranslationKey(value), path: propertyPath });
            }
            else if (Array.isArray(value)) {
                value.forEach((entry, index) => {
                    if (typeof entry === 'string') {
                        result.push({
                            property,
                            key: normalizeTranslationKey(entry),
                            path: `${propertyPath}[${index}]`,
                        });
                    }
                });
            }
        }
        collectTranslationReferences(value, propertyPath, result);
    }
    return result;
}
export function findMissingTranslationReferences(node, hasKey, path = 'descriptor') {
    return collectTranslationReferences(node, path).filter((reference) => !hasKey(reference.key));
}
